import { Expose } from 'class-transformer';

export class ModelSate {
    @Expose()
    code: string;

    @Expose()
    name: string;
}
